import Emitter from './emitter'

import { isEmitter } from './bits'
import { isFunction } from 'lodash-es'

const defined = true
  && isFunction(window.ggsForceResize)
  && isEmitter(window.ggsForceResize.emitter)

let exports = null

if (defined) {
  exports = window.ggsForceResize
} else {
  const emitter = Emitter('forceResize')
  const message = 'ggsForceResize'
  const ggsForceResize = () => emitter.emit(message)

  exports = window.ggsForceResize = ggsForceResize
  exports.emitter = emitter
}

export default exports
